import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M17.5 8c-.276 0-.5.224-.5.5v2.652A10.4903 10.4903 0 0 0 9.5 8c-1.679 0-3.284.385-4.77 1.144-1.417.724-2.672 1.78-3.63 3.055a.5004.5004 0 0 0 .099.7c.09.068.195.1.3.1.152 0 .302-.069.4-.2C3.713 10.384 6.483 9 9.499 9c2.633 0 5.134 1.088 6.928 3h-2.928c-.276 0-.5.224-.5.5s.224.5.5.5h4c.276 0 .5-.224.5-.5v-4c0-.276-.224-.5-.5-.5z',
  ],
  height: 20,
  width: 20,
});
